import { render, staticRenderFns } from "./PrivacyMobile.vue?vue&type=template&id=14dd6e0f&scoped=true"
import script from "./PrivacyMobile.vue?vue&type=script&lang=js"
export * from "./PrivacyMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd6e0f",
  null
  
)

export default component.exports